import { BrowserRouter, Routes, Route, Navigate, useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Portal from './pages/Portal.jsx';
import Admin from './pages/Admin.jsx';

function SlugRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    fetch('/api/tenant-by-slug/' + slug)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(d => {
        navigate('/?tenant=' + d.tenant_id, { replace: true });
      })
      .catch(() => setError(true));
  }, [slug]);

  if (error) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="text-white text-center">
        <p className="text-2xl mb-2">⚠️</p>
        <p>URLが見つかりません</p>
        <a href="/" className="text-indigo-400 underline mt-2 block">ホームへ戻る</a>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="text-white text-center">
        <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
        <p className="text-slate-300 text-sm">読み込み中...</p>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portal />} />
        <Route path="/t/:slug" element={<SlugRedirect />} />
        <Route path="/admin/*" element={<Admin />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
